import { TrackableButton } from '@components/TrackableButton/TrackableButton'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ContactUsModal } from './ContactUsModal'

interface ContactUsButtonProps {
	variant?: 'button' | 'link'
}

const ContactUsButton = ({ variant = 'button' }: ContactUsButtonProps) => {
	const { t } = useTranslation()
	const [open, setOpen] = useState(false)

	const handleOpen = useCallback(() => {
		setOpen(true)
	}, [])

	const handleClose = useCallback(() => {
		setOpen(false)
	}, [])

	const handleLinkClick = useCallback(
		(event: React.MouseEvent<HTMLAnchorElement>) => {
			event.preventDefault()
			setOpen(true)
		},
		[]
	)

	return (
		<>
			{variant === 'link' ? (
				// eslint-disable-next-line jsx-a11y/anchor-is-valid
				<a href="" onClick={handleLinkClick}>
					{t('button.contactUs')}
				</a>
			) : (
				<TrackableButton
					eventText="Contact Us"
					variant="contained"
					onClick={handleOpen}
				>
					{t('button.contactUs')}
				</TrackableButton>
			)}
			<ContactUsModal open={open} onClose={handleClose} />
		</>
	)
}

export { ContactUsButton }
